import "assets/css/terminals.css";

export const CardFrame = ({ cardClass, headerClass, bodyClass, title, children, footer }) => {
  return (
    <div className={` card shadow rounded overflow-hidden ${cardClass || "my-4 mx-2"}`}>
      {title && (
        <div className={`card-header bg-dark text-white rounded-top ${headerClass || ""}`}>
          {title}
        </div>
      )}
      <div className={`card-body ${bodyClass || ""}`}>
        {children}
      </div>
      {footer && (
        <div className="card-footer rounded-bottom">
          {footer}
        </div>
      )}
    </div>
  );
};
